import { render, staticRenderFns } from "./DraftProduct.vue?vue&type=template&id=3c0b4672&"
import script from "./DraftProduct.vue?vue&type=script&lang=js&"
export * from "./DraftProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports